export default {"src":"/_next/static/media/logo.9bce43e9.svg","height":411,"width":2620,"blurWidth":0,"blurHeight":0};